import { getStorefrontClient } from '#libs'
import type { Product } from '#libs/shopify'
import { isEmpty } from 'lodash'

export const fetchProductByHandle = async (handle: string) => {
  const client = getStorefrontClient()

  if (!client || isEmpty(handle)) {
    // eslint-disable-next-line no-console
    console.error('Missing required info!', handle)

    return null
  }

  const query = `query productByHandle($handle: String) {
    product(handle: $handle) {
      id
      title
      handle
      onlineStoreUrl
      tags
      variants (first: 50) {
        nodes {
          id
          availableForSale
          selectedOptions {
            name
            value
          }
        }
      }
    }
  }`
  const { data, errors } = await client.request(query, { variables: { handle } })

  if (errors) {
    // eslint-disable-next-line no-console
    console.error(`Failed to query product with handle "${handle}"!`, errors)

    return null
  }

  return data.product as Product
}
